import { gql } from '@provision/graphql-client';

export const SIGNAL_INCIDENT_TIMELINE_FIELDS = gql`
  fragment SignalIncidentTimelineFields on SignalIncident {
    id
    signalIncidentId
    conversationId
    partnerId
    status
    createdAt
    resolvedAt
    resolvedBy
    notificationLog
    conversationUrgencyId
    conversationUrgency {
      id
      urgencyName
    }
    resolver {
      id
      userId
      firstName
      lastName
    }
  }
`;
